export const DOCUMENT_VALIDATION_ERRORS = {
  CPF_ALREADY_IN_USE: 'CPF_ALREADY_VALIDATED_OTHER_PROFILE',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  FAILED_TO_EXTRACT_CPF: 'FAILED_TO_EXTRACT_CPF',
  FAILED_TO_GET_DOC_ENTITY: 'FAILED_TO_GET_DOC_ENTITY',
  EXTRACTED_CPF_DOES_NOT_MATCH_PROFILE_CPF: 'EXTRACTED_CPF_DOES_NOT_MATCH_PROFILE_CPF',
  ENTITY_TOO_LARGE: 'ENTITY_TOO_LARGE',
} as const

export const DOCUMENT_VALIDATION_ERROR_MESSAGES = {
  NO_CPF_TEXT_FOUND: 'no cpf text found',
  FAILED_TO_GET_DOC_ENTITY: 'failed to get doc entity',
  ENTITY_TOO_LARGE_CODE: '413',
} as const

interface ErrorInfo {
  key?: keyof typeof DOCUMENT_VALIDATION_ERRORS
  message?: string
}

interface ErrorResponse {
  graphQLErrors?: { info: ErrorInfo }[]
  message?: string
}

export type DocumentValidationErrorType =
  (typeof DOCUMENT_VALIDATION_ERRORS)[keyof typeof DOCUMENT_VALIDATION_ERRORS]

export function identifyDocumentValidationError(error: ErrorResponse): {
  type: DocumentValidationErrorType
  message?: string
} {
  if (error?.message?.includes(DOCUMENT_VALIDATION_ERROR_MESSAGES.ENTITY_TOO_LARGE_CODE)) {
    return { type: DOCUMENT_VALIDATION_ERRORS.ENTITY_TOO_LARGE }
  }

  if (error.graphQLErrors) {
    const { key, message = 'Unknown error' } = error?.graphQLErrors?.[0]?.info || {}

    if (key === DOCUMENT_VALIDATION_ERRORS.VALIDATION_ERROR) {
      if (message?.includes(DOCUMENT_VALIDATION_ERROR_MESSAGES.NO_CPF_TEXT_FOUND)) {
        return { type: DOCUMENT_VALIDATION_ERRORS.FAILED_TO_EXTRACT_CPF, message }
      }
      if (message?.includes(DOCUMENT_VALIDATION_ERROR_MESSAGES.FAILED_TO_GET_DOC_ENTITY)) {
        return { type: DOCUMENT_VALIDATION_ERRORS.FAILED_TO_GET_DOC_ENTITY, message }
      }
    }

    return {
      type: (key as DocumentValidationErrorType) || DOCUMENT_VALIDATION_ERRORS.VALIDATION_ERROR,
      message,
    }
  }

  return {
    type: DOCUMENT_VALIDATION_ERRORS.VALIDATION_ERROR,
    message: 'Unknown error',
  }
}

export const DOCUMENT_ERROR_TYPES = new Set<DocumentValidationErrorType>([
  DOCUMENT_VALIDATION_ERRORS.FAILED_TO_GET_DOC_ENTITY,
  DOCUMENT_VALIDATION_ERRORS.FAILED_TO_EXTRACT_CPF,
  DOCUMENT_VALIDATION_ERRORS.EXTRACTED_CPF_DOES_NOT_MATCH_PROFILE_CPF,
  DOCUMENT_VALIDATION_ERRORS.ENTITY_TOO_LARGE,
])

export function isDocumentValidationError(type: DocumentValidationErrorType): boolean {
  return DOCUMENT_ERROR_TYPES.has(type)
}
